/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC, lazy } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import { RootState } from '../../setup'
import { Logout } from '../modules/auth'
import AuthPageWrapper from '../pages/auth/AuthPageWrapper'
import AppLayout from './AppLayout'

const Routes: FC = () => {
  const { user } = useSelector((root: RootState) => root.auth, shallowEqual)
  const Confirmation = lazy(() => import('../pages/auth/features/Confirmation'));
  const PasswordConfirm = lazy(() => import('../pages/auth/features/PasswordConfirm'));
  return (
    <Switch>
      <Route path={`/activate-account/:id/:token`} component={Confirmation} />
      <Route path={`/reset-password/:user/:token`} component={PasswordConfirm} />
      <Route path='/auth' component={AuthPageWrapper}/>
      <Route path='/logout' component={Logout} />
      <Route>
        <AppLayout user={user} />
      </Route>
    </Switch>
  )
}

export { Routes }

